import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asteriscoToLabel'
})
export class AsteriscoToLabelPipe implements PipeTransform {

  transform(label: string, required: boolean): string {
    return required ? label + '*' : label
  }

}
